import { AxiosResponse } from 'axios';

import { LoginBody, Profile } from '../pages/Login.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

interface ResponseSuccessPostLogin extends ResponseREST {
	data: Profile;
}

export const postLogin = async (
	body: LoginBody,
): Promise<ResponseSuccessPostLogin> => {
	return axiosInstance
		.post('api-login', body)
		.then((res: AxiosResponse<ResponseSuccessPostLogin>) => res.data)
		.catch((err) => err);
};
